import { Injectable } from '@angular/core';
import { ConfigurationService } from '../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  Domain: any = null;
  constructor(private config: ConfigurationService) {
    this.Domain = this.config.environmentURL();
  }
  setCookie(name: string, value: string): void {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    if (window.location.host.includes('localhost')) {
      document.cookie = `${name}=${value};` + `expires=${expires.toUTCString()};` + `path=/`;
    } else {
      document.cookie = `${name}=${value};` + `expires=${expires.toUTCString()};` + `path=/;` + `domain=${this.Domain};` + `secure;samesite=lax`;
    }
  }
  getCookie(name: string): string {
    const cookieName = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length);
      }
    }
    return '';
  }
}
